<div class="d-flex justify-content-end ds-gap-4">
  <ds-button
    color="secondary"
    size="md"
    [label]="previousLabel"
    dsStepperPrevious
    [disabled]="disabledPrevious"
    (click)="onPrevious.emit()"
    [fixedWidth]="'120px'"
    [width]="'fixed'"
  ></ds-button>
  <ds-button
    color="primary"
    size="md"
    [label]="nextLabel"
    dsStepperNext
    [disabled]="disabledNext"
    (click)="onNext.emit()"
    [fixedWidth]="'120px'"
    [width]="'fixed'"
  ></ds-button>
</div>
